import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

const MessageContainer = styled.div`
  /* スクロールスナップの設定 */
  scroll-snap-align: start;
`;

const MessageTitle = styled(motion.h2).attrs({
  className: "u-w100",
})`
  font-family: "A+mfCv-AXISラウンド 50 L StdN", "M PLUS 1p", sans-serif;

  font-size: clamp(1.313rem, 0.849rem + 2.32vw, 2.5rem);
  line-height: 187.5%;
  // letter-spacing: 0.75rem;

  margin-bottom: 48px;
`;

const MessageBody = styled(motion.p).attrs({
  className: "bodytext u-w100",
})`
  max-width: 640px;
  line-height: 200%;
  text-align: justify;
`;

const CareersMessage: React.FC = () => {
  return (
    <MessageContainer className="u-fullpage u-col-center u-items-center">
      <MessageTitle
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1 }}
        viewport={{ once: true, amount: 0.5 }}
      >
        動けば、世界は変わる。
      </MessageTitle>
      <MessageBody
        initial={{ opacity: 0, y: 16 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 1, delay: 0.3 }}
        viewport={{ once: true, amount: 0.3 }}
      >
        人は生まれながらにして動く存在です。好奇心のままに一歩を踏み出すたび、未知の発見が待っています。歴史を振り返れば、未踏の地へ向かったその一歩こそが、人類を進化させてきました。
        <br /><br />
        もちろん移動は、ときに不安や痛みを伴います。けれども「何かを変えたい」「今までにないものを生み出したい」という衝動に従い、君が踏み出すその一歩を、私たちはそっと後押しします。
      </MessageBody>
    </MessageContainer>
  );
};

export default CareersMessage;
